import { HTTP_METHOD } from "../../../helper/constants";
import request from "../../request";

export const authApi = {
  logout: () => {
    const url = `/logout`;
    return request({
      method: HTTP_METHOD.GET,
      url,
    });
  },
  loginUrl: () => {
    const url = `/login`;
    return request({
      method: HTTP_METHOD.GET,
      url,
    });
  },
  login: (credentials) => {
    const url = `/auth/login`;
    return request(
      {
        method: HTTP_METHOD.POST,
        url,
        data: credentials,
        headers: {
          "Content-Type": "application/json",
        },
        responseType: "json",
      },
      false // showErrorToast = false - Handle error manually in component
    );
  },
  /**
   * Credential login that bypasses SSO, used when ?internallogin=true.
   * Takes { employeeId, password }, matching /auth/login.
   *
   * Unauthenticated by design — this is the call that creates the session. The
   * endpoint must be disabled server-side in prod. The server replies with an
   * HttpOnly session cookie, so nothing is returned here that the client needs
   * to persist; withCredentials on the axios instance carries the session on
   * every later call.
   */
  createInternalSession: (credentials) => {
    const url = `/internal/session/create`;
    return request(
      {
        method: HTTP_METHOD.POST,
        url,
        data: credentials,
        headers: {
          "Content-Type": "application/json",
        },
        responseType: "json",
      },
      false // showErrorToast = false - the login form renders the error inline
    );
  },
  checkFeatureStatus: (featureName) => {
    const url = `/feature/status`;
    return request(
      {
        method: HTTP_METHOD.GET,
        url,
        params: { featureName },
        headers: {
          "Content-Type": "application/json",
        },
        responseType: "json",
      },
      false // showErrorToast = false - Handle error manually
    );
  },
};

export default authApi;
